export default "__VITE_ASSET__DYa6Jmse__"